(function($, moment) {
	"use strict";

	/*
	 * C'est un plugin jQuery qui permet de réagir au changement sur un composant éditable.
	 * Il est utile car IE ne lance pas de 'change' avant qu'on sorte de la zone, même si on appuie sur 'enter'.
	 * Il écoute donc les 'change' et les 'keyup' sur la touche 13 (enter) et lance alors un évènement 'changeorkeyupenter'.
	 */
	$.fn.activateChangeOrKeyUpEnter = function() {
		return this.on('change keyup', function(event) {
			if (event.type === 'change' || (event.keyCode === 10 || event.keyCode === 13))
				$(this).trigger('changeorkeyupenter');
		});
	};

	/*
	 * C'est un plugin jQuery qui ajuste la hauteur d'une textarea automatiquement
	 */
	$.fn.autoExpandTextarea = function(collapseHeight) {
		return this.each(function() {
			var self = $(this);

			function autoExpand() {
				// Comme "scrollHeight" ne diminue pas quand on réduit le texte, le seul moyen d'avoir
				// un scrollHeight correct est de réduire la textarea pour la réajuster ensuite
				if (collapseHeight)
					self.innerHeight(collapseHeight);
				// scrollHeight (standard) donne la hauteur du contenu avec padding et ni margin, ni border
				// innerHeight (jquery) change la hauteur en incluant padding mais ni margin, ni border
				self.innerHeight(self[0].scrollHeight);
			}

			function waitForInsert() {
				if (self.parents('body').length)
					autoExpand();
				else
					setTimeout(waitForInsert, 100);
			}

			self.css('overflow-y', 'hidden').on('input', autoExpand);
			waitForInsert();
		});
	};

	/**
	 * Ce composant jQuery s'applique à une image pour lui donner une taille équivalente à "object-fit: scale-down; ".
	 * Fonctionne ssous FF, Chrome et IE11 (contrairement à object-fit).
	 */
	$.fn.scaleDownImage = function() {
		return this.wrap('<div style="display:flex; align-items: center; width: 100%; height: 100%; " />').css({
			'flex': 'none',
			'margin': 'auto',
			'max-width': '100%',
			'max-height': '100%'
		});
	};

	/*
	 * Ce composant jQuery permet de détecter le redimensionnement d'un composant.
	 * En effet, l'évènement "onresize" n'est disponible que sur les "window".
	 * Pour détecter l'évènement, on crée une "iframe" cachée, au sein du conteneur donné.
	 * Cette "iframe" nous préviendra en cas d'évènement "onresize" sur sa "window".
	 * Le composant lancera alors un évènement "detectresize", pour le distinguer des "resize".
	*/
	$.fn.detectResize = function(param) {
		// 1. Création
		if (typeof param === 'undefined') {

			var iframeStyle = {
				'opacity': 0,
				'position': 'absolute',
				'top': 0,
				'left': 0,
				'width': '100%',
				'height': '100%'
			};

			var iframeDocument = ''
				+ '<html>'
				+ '  <head>'
				+ '    <style>html, body { margin: 0; padding: 0; width: 100%; height: 100%; }</style>'
				+ '  </head>'
				+ '  <body>'
				+ '    <script>window.addEventListener("resize", function() { window.parent.postMessage("detectresize", "*", []); });</script>'
				+ '  </body>'
				+ '</html>';

			return this.each(function() {
				// On crée une iframe ivde au départ
				var iframe = $('<iframe class="detect-resize" src="about:blank" />');
				// On l'ajoute au conteneur (en prepend pour que l'iframe reste derrière le contenu réel)
				var self = $(this).prepend(iframe);
				// On modifie par JS le contenu de l'iframe
				// - open + write + close est la seule méthode que j'ai trouvée qui ne nécessite pas un fichier html en plus
				// - iframe.attr('srcdoc', iframeDocument) ne fonctionne ni sous Edge, ni sous IE11
				// - iframe.attr('src', path + 'jquery-plugins/iframe-detectresize.html') fonctionnerait mais nous oblige à gérer un fichier en chemin relatif
				// - iframe.attr('src', 'data:text/html;' + encodeURIComponent(iframeDocument)) ne fonctionne pas sous IE11
				// - iframe.attr('src', 'data:text/html;base64,' + btoa(iframeDocument)) ne fonctionne pas sous IE11
				var doc = iframe[0].contentWindow.document;
				doc.open();
				doc.write(iframeDocument);
				doc.close();

				function onDetectResize(e) {
					if (e.originalEvent && e.originalEvent.data === 'detectresize')
						self.trigger('detectresize');
				}

				iframe.css(iframeStyle);
				iframe.on('remove', function() { $(window).off('message', onDetectResize); });
				$(window).on('message', onDetectResize);
			});
		}
		// 2. Destruction
		if (param === 'destroy') {
			this.children('iframe.detect-resize').remove();
			return this;
		}
		// 3. Erreur
		throw new Error('Paramètre non valide ' + param);
	};

	/**
	 * C'est un plugin jQuery qui écoute détecte la séquence d'évènements (mousedown => mousemove* => mouseup).
	 * A chaque étape, il peut appeler les callback "options.down", "options.move" et "options.up" si précisées.
	 */
	$.fn.mouseDrag = function(options) {
		// Quand la souris est pressée, on commence le drag et l'écoute
		return $(this).on('mousedown', function(event) {
			var b = $(document.body);
			// Callback pour finir le down/move*/up
			var uc = function(event) {
				// On arrête d'écouter les "mousemove"
				b.off('mousemove', mc);
				// On prévient le listener éventuel
				if (options.up)
					options.up(event);
			};
			// Callback quand on bouge la souris
			var mc = function(event) {
				// Si event.buttons est 0, c'est que le bouton a été relâché à l'extérieur de la grille.
				// Du coup, on n'a pas eu le "mouseup" mais dès qu'on s'en aperçoit, on arrête de bouger.
				if (event.buttons === 0) {
					uc(event);
				} else {
					// On prévient le listener éventuel
					if (options.move)
						options.move(event);
				}
			};
			// On écoute les "mousemove" sur "body" pour ne pas en rater
			b.on('mousemove', mc);
			// On écoute un seul "mouseup" pour terminer le drag
			b.one('mouseup', uc);
			// On prévient le listener éventuel
			if (options.down)
				options.down(event);
		});
	};

	/**
	 * C'est un plugin jQuery qui écoute la molette et prévient en appelant les fonctions fournies
	 * 
	 * @param {Function} wheel une fonction facultative appelée en passant un booléen qui indique la direction (true vers le haut, false sinon)
	 * @param {Function} wheelUp une fonction facultative appelée uniquement si la molette va vers le haut
	 * @param {Function} wheelDown une fonction facultative appelée uniquement si la molette va vers le bas
	 */
	$.fn.wheelUpDown = function(onwheel, onwheelup, onwheeldown) {
		return this.on('wheel', function wheel(event) {
			// Ne pas scroller dans le document
			event.preventDefault();

			// Recupérer le décallage (>0 = vers le haut)
			var delta;
			if (typeof event.originalEvent.deltaY === 'number')
				delta = -event.originalEvent.deltaY;
			else if (typeof event.originalEvent.wheelDelta === 'number')
				delta = event.originalEvent.wheelDelta;
			else if (typeof event.originalEvent.detail === 'number')
				delta = -event.originalEvent.detail;
			else
				return;

			// Prévenir appelant la ou les callbacks fournies
			if (typeof onwheel === 'function')
				onwheel(delta > 0);
			if (typeof onwheelup === 'function' && delta > 0)
				onwheelup();
			if (typeof onwheeldown === 'function' && delta < 0)
				onwheeldown();
		});
	};

	/*
	 * C'est un plugin jQuery qui écoute la manipulation au doigt et envoie des évènements "swipe" en indiquant la direction et la durée du mouvement.
	 * Le code a été repris d'ici : https://github.com/guillaumeprevot/nimbus/blob/master/public/libs/gp/gp.js
	 */
	$.fn.swipe = function() {
		return this.addClass('swipe').on('touchstart', function(startEvent) {
			var startX, startY, startTime, moveX, moveY;
			var target = $(startEvent.target).closest('.swipe');
			function touchmove(event) {
				var t = event.originalEvent.touches;
				if (t) {
					moveX = t[0].clientX;
					moveY = t[0].clientY;
				}
			}
			var t = startEvent.originalEvent.touches;
			if (t) {
				startX = t[0].clientX;
				startY = t[0].clientY;
				startTime = Date.now();
				$(document).on('touchmove', touchmove).one('touchend', function() {
					$(document).off('touchmove', touchmove);
					var radians = Math.atan2((startY - moveY), (moveX - startX));
					var directions = ['left', 'bottomleft', 'bottom', 'bottomright', 'right', 'topright', 'top', 'topleft'];
					var index = Math.floor((radians + Math.PI + Math.PI / 8) / (Math.PI / 4)) % 8;
					target.trigger('swipe', [{ direction: directions[index], duration: Date.now() - startTime }]);
					// target.trigger('swipe.' + directions[index]);
				});
			}
		});
	};

	/*
	 * C'est un plugin jQuery qui fait apparaître un bouton dès qu'on scrolle permettant de remonter en haut de la page
	 * ATTENTION : ce plugin n'est pas utilisé par SOLVNet mais il est utilisé par SAM et Inside
	 */
	$.fn.backToTop = function(userOptions) {
		// Default settings
		var defaultOptions = {
			zIndex: 1,
			distance: 10,
			title: 'Back to top',
			contentHTML: '<span class="glyphicon glyphicon-arrow-up"></span>',
			buttonClass: 'back-to-top',
			scrollableElement: document
		};

		// Used settings, merge of userOptions in defaultOptions
		var options = $.extend({}, defaultOptions, userOptions || {});

		// Walk through elements where we will create buttons
		this.each(function() {
			// The existing DOM container
			var container = $(this);

			// The new button
			var button = $('<a href="#" class="btn btn-default" />')
				.addClass(options.buttonClass)
				.css('position', 'fixed')
				.css('z-index', '' + options.zIndex)
				.css('bottom', options.distance + 'px')
				.css('right', options.distance + 'px')
				.attr('title', options.title)
				.html(options.contentHTML)
				.appendTo(container)
				.hide();

			// The scrollTop is on 'html' on IE/FF but on 'document.body' on Chrome
			var html = $('html').get(0);
			$(options.scrollableElement).scroll(function() {
				if ((options.scrollableElement === document && (html.scrollTop || document.body.scrollTop || 0) > 0)
						|| (options.scrollableElement !== document && options.scrollableElement.scrollTop > 0))
					button.filter(':not(:visible)').fadeIn();
				else
					button.filter(':visible').fadeOut();
			});

			// Not "required" because it works fine with default behaviour.
			// But, the following will keep "hash" intact in URL
			button.click(function(event) {
				event.preventDefault();
				if (options.scrollableElement === document && html.scrollTop)
					html.scrollTop = 0;
				if (options.scrollableElement === document && document.body.scrollTop)
					document.body.scrollTop = 0;
				if (options.scrollableElement !== document && options.scrollableElement.scrollTop)
					options.scrollableElement.scrollTop = 0;
			});
		});

		// Chaining
		return this;
	};

	/**
	 * C'est un plugin qui étend le popver pour Bootstrap pour ajuster si besoin
	 * la position (top ou left) si elle est négative
	 */
	$.fn.popoverWithCheckBounds = function(options) {
		var self = this;
		return this.popover(options).on('inserted.bs.popover', function(event) {
			var popover = self.children('.popover').css('visibility', 'hidden');
			setTimeout(function() {
				var horizontal = popover.hasClass('right') || popover.hasClass('left');
				var propertyName = horizontal ? 'top' : 'left';
				var propertyValue = popover.css(propertyName);
				var offset, arrow;
				if (propertyValue.charAt(0) === '-') {
					offset = -parseFloat(propertyValue);
					popover.css(propertyName, '0px');
					arrow = popover.children('.arrow');
					arrow.css(propertyName, 'calc(' + arrow[0].style[propertyName] + ' - ' + offset + 'px)');
				}
				popover.css('visibility', '');
			}, 200);
		});
	};

	/**
	 * C'est un plugin qui étend le popover pour Bootstrap pour fixer la position
	 * en absolue. La position est obtenue en connectant "mouseenter" et le parent
	 * est forcé en "document.body". De plus, un seul "popover" existera à la fois.
	 */
	$.fn.popoverWithAbsolutePosition = function(options) {
		var popoverParent = $(document.body);
		var clientX, clientY;

		// On force le parent pour position nous-même
		options.container = popoverParent;

		// On note la position quand la souris entre dans les éléments demandant un popover
		function preparePosition(event) {
			clientX = event.originalEvent.clientX;
			clientY = event.originalEvent.clientY;
		}

		// On ajuste la position quand le popover est inséré, avant même qu'il soit affiché
		function applyPosition() {
			// Cacher le popover avant qu'il apparaisse car la position n'est pas bonne.
			// En effet, les "area" ne semblent pas retourner les positions correctes
			var popover = popoverParent.children('.popover').css('visibility', 'hidden');
			setTimeout(function() {
				// Cacher la flêche plutôt que de chercher à la caler sur le popover
				popover.children('.arrow').hide();
				// Afficher le popover à la position liée à l'événement déclencheur de l'ouverture
				// en prenant en compte la place restante en bas de la page et sur le coté droit
				popover.css({
					left: (window.innerWidth < (clientX + popover.width()) ? (clientX - popover.width()) : clientX) + 'px',
					top: (window.innerHeight < (clientY + popover.height()) ? (clientY - popover.height()) : clientY) + 'px',
					visibility: 'visible'
				});
			}, 200);
		}

		// Si pas encore enregistré
		if (!$.fn.popoverWithAbsolutePosition.bodyRegistered) {
			// Passer à true pour ne pas enregistrer une deuxième fois
			$.fn.popoverWithAbsolutePosition.bodyRegistered = true;
			// Enregistrer une callback sur body
			var body = $(document.body).on('mousedown', function(e) {
				// Supprimer le popover sauf si on clique dans un popover
				if ($(e.target).closest('.popover').length === 0)
					body.children('.popover').popover('destroy');
			});
		}

		return this
			.on('mouseenter', options.selector, preparePosition)
			.on('inserted.bs.popover', applyPosition)
			.popover(options);
	};
	// Pour la gestion de l'enregistrement de l'événement qui ferme les popovers
	$.fn.popoverWithAbsolutePosition.bodyRegistered = false;

	$.fn.popoverCheckBounds = function(container) {
		return this.on('inserted.bs.popover', function(event) {
			// On converse le popover associé au cas ou on aurait du propre à faire dans Xms.
			var $currentPopver = $(this).data('bs.popover').$tip;

			// Cacher tous les popover avant qu'il n'apparaisse car la position n'est pas bonne.
			container.children(".popover").css('visibility', 'hidden');
			setTimeout(function() {
				if($currentPopver.data("bs.popover").$element.parents('body').length === 0) {
					// Ce popover n'a plus de composant visible, c'est qu'il a supprimé pendant l'interval.
					$currentPopver.remove();
					return;
				}
				// Cacher la flêche plutôt que de chercher à la caler sur le popover
				$currentPopver.children('.arrow').hide();
				// Vérifier si la position 'top' ou 'left' est correcte
				function check(propertyName) {
					var propertyValue = $currentPopver.css(propertyName);
					var offset;
					if (propertyValue.charAt(0) === '-') {
						offset = -parseFloat(propertyValue);
						$currentPopver.css(propertyName, '0px');
					}

				}
				check('top');
				check('left');
				// Réafficher le popover maintenant que la position a été vérifiée
				$currentPopver.css({
					'visibility': '',
					'max-width': 'none'
				});
			}, 200);//JEROME Voir si on peut encore le réduire quand lorris aura réalisé le refreshForm.
		});
	};

	$.fn.datepickerInPopover = function(options) {
		return this.each(function(){
			// Container pour popoverCheckBounds. Forcer a body pour afficher completement le popover
			var container = $(document.body);
			// Obligatoire pour le bon fonctionnement
			options.inline = true;

			// Datetimepicker de type date, heure ou date/heure
			var calendar = $('<div/>').datetimepicker(options);
			// On désactive le fonctionnement natif du bouton fermer pour ne pas perdre le calendar initial
			if (options.showClose)
				calendar.find('.glyphicon-remove')
					.parent().removeAttr('data-action')
					.on('click', function(e) {
						e.preventDefault();
						$(this).closest('.popover').popover('hide');
					});
			// On surcharge le fonctionnement natif du bouton clear car le calendar n'est pas lié à l'input
			if (options.showClear)
				calendar.find('.glyphicon-trash')
					.on('click', function(e) {
						calendar.data('DateTimePicker').date(null);
						$(this).closest('.popover').popover('hide');
					});

			// On nettoie les popoover qui traine qui ne devrait plus être là
			container.children(".popover").filter(function() {
				return $(this).data("bs.popover").$element.parents('body').length === 0;
			}).remove();

			// Input clickable
			var input = $(this)
				.attr('data-trigger', 'focus') // Pour que le popover se ferme quand on click ailleur sur la page
				.on('click', function() {
					// Si le composant a déjà le focus et qu'on a refermé le popover, il ne se réouvrira pas sans une perte préalable du focus.
					// On s'assure que sur un click , on réouvre le popover.
					if(! container.children('.popover').is(':visible')) {
						$(this).popover('show');
					}
				})
				.popoverCheckBounds(container)
				.popover({
					container: container,
					html: true,
					placement: 'auto bottom',
					template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
					content: function() {
						// Positionnement sur une date particulière à chaque affichage
						var v = input.attr('data-default-value');
						var m = (v && !input.val()) ? moment(v, options.format) : null;
						if (m !== null)
							// .viewDate(m) ne fonctionne pas alors on utilise .date(m).date(null);
							calendar.data('DateTimePicker').date(m).date(null);
						// (ré-)Initialisation de l'indicateur de modification
						calendar.attr('data-changed', 'false');
						// On réaffiche toujours le calendar lié au composant
						return calendar;
					}
				}).on('inserted.bs.popover', function(e) {
					$(this).data('bs.popover').$tip.css('z-index','65000');
				}).on('hide.bs.popover', function(e) {
					var calendarMoment = calendar.data('DateTimePicker').date();
					var oldValue = input.val();
					var newValue = calendarMoment ? calendarMoment.format(options.format) : '';
					if (newValue !== oldValue || calendar.attr('data-changed') === 'true') {
						input.val(newValue).change();
						calendar.attr('data-changed', 'false');
					}
				}).on('input', function() {
					// En cas de saisie manuelle, maintenir le calendrier synchrone
					calendar.data('DateTimePicker').date(input.val());
					// Indiquer qu'il y a eu une saisie manuelle pour lancer le "change" une fois caché
					calendar.attr('data-changed', 'true');
				});
		});
	};
	
	$.fn.datepickerInModal = function(options) {
		return this.each(function(){
			var container = $(document.body);
			// Obligatoire pour le bon fonctionnement
			options.inline = true;
			
			// Datetimepicker de type date, heure ou date/heure
			var calendar = $('<div/>').datetimepicker(options);
			// On désactive le fonctionnement natif du bouton fermer pour ne pas perdre le calendar initial
			if (options.showClose)
				calendar.find('.glyphicon-remove')
					.attr('data-dismiss', 'modal')
					.parent().removeAttr('data-action');
			// On surcharge le fonctionnement natif du bouton clear car le calendar n'est pas lié à l'input
			if (options.showClear)
				calendar.find('.glyphicon-trash')
					.attr('data-dismiss', 'modal')
					.parent().removeAttr('data-action')
					.on('click', function(e) {
						calendar.data('DateTimePicker').date(null);
					});

			container.children(".modal-datetime").remove();

			// Input clickable
			var input = $(this).attr('data-backdrop', 'static').attr('data-target', '.modal-datetime')
				.on('click', function() {
					var v = input.attr('data-default-value');
					var m = (v && !input.val()) ? moment(v, options.format) : null;
					if (m !== null)
						// .viewDate(m) ne fonctionne pas alors on utilise .date(m).date(null);
						calendar.data('DateTimePicker').date(m).date(null);
					// (ré-)Initialisation de l'indicateur de modification
					calendar.attr('data-changed', 'false');
					// On réaffiche toujours le calendar lié au composant
					modal.find('.modal-body').append(calendar);
					modal.modal('show');
					
				}), 
				modal = $('<div class="modal"><div class="modal-dialog"><div class="modal-content"><div class="modal-body" /></div></div></div>')
				.on('hide.bs.modal', function(e) {
					var calendarMoment = calendar.data('DateTimePicker').date();
					var oldValue = input.val();
					var newValue = calendarMoment ? calendarMoment.format(options.format) : '';
					if (newValue !== oldValue || calendar.attr('data-changed') === 'true') {
						input.val(newValue).change();
						calendar.attr('data-changed', 'false');
					}
				});
		});
	};

	/**
	 * C'est un plugin jquery qui transporte un textArea dans un popover et injecte a la place du textarea dans l'arbre dom un bouton.
	 */
	$.fn.popoverTextarea = function(readonly) {
		var editor = $(this),
			parent = editor.parent();

		editor.detach(); // on retire l'editeur de l'arbre dom
		/* si on ne fixe pas une taille au textarea, lorsque l'on appellera "popoverWithAbsolutePosition" alors
		 * le textarea créé dedans aura une taille petite et la hauteur sera grande afin de contenir la valeur.
		 * Developpement lié au problème : https://support.solvnet.fr:9998/devels/edit/3578 
		 */
		editor.css('width', '200px');
		var button = $('<button class="btn btn-default" style="width:100%; "/>')
			.addClass(editor.attr('class')) // pour avoir les classes de l'éditeur
			.removeClass('form-control') // mais on ne veut pas la classe form-control
			.append($('<span />') // pour pouvoir avoir les points de suspension dans le bouton
					.text(editor.val())
					.css('text-overflow', 'ellipsis')
					.css('display', 'block')
					.css('overflow', 'hidden')
			)
			.data('textarea', editor) // on lie l'éditeur au bouton
			.appendTo(parent);

		parent.popoverWithAbsolutePosition({
			selector: 'button',
			trigger: 'click',
			html: true,
			container: '.bbm-grid',
			content: function() {
				return editor.autoExpandTextarea(); // on agrandit automatiquement le textarea afin qu'il s'adapte à son contenu;
			}
		})
		.on('shown.bs.popover', function() {
			if (readonly)
				$('.popover').find('textarea').attr('readonly', 'readonly');
			else
				setTimeout(function() { $('.popover').find('textarea').focus(); }, 100);

		})
		.on('hidden.bs.popover', function() {
			button.find('span').text(editor.val());
		});
	};
	
	/**
	 * Par défaut, "devbridgeAutocomplete" aligne la gauche des suggestions avec la gauche de l'input.
	 * Hors, comme on ne souhaite pas limiter la largeur de la liste de suggestions, ça dépasse souvent à droite de l'écran.
	 * Du coup, le plugin ci-dessous, après avoir appelé "devbridgeAutocomplete", va surcharger la méthode "fixPosition".
	 * Le correctif consiste à aligner les suggestions en dessous et de caler la droite sur la droite de l'input.
	 */
	$.fn.devbridgeAutocompleteRightAligned = function(options, args) {
		return this.devbridgeAutocomplete(options, args).each(function() {
			var autocomplete = $(this).data('autocomplete');
			autocomplete.fixPosition = function() {
				var inputOffset = this.el.offset();
				var inputWidth = this.el.outerWidth();
				var inputHeight = this.el.outerHeight();
				var $container = $(this.suggestionsContainer);
				$container.find('.autocomplete-suggestion').css({
					'white-space': 'nowrap',
					'padding-right': '18px'
				});
				$container.css({
					'top': (inputOffset.top + inputHeight) + 'px',
					'right': 'calc(100% - ' + (inputOffset.left + inputWidth) + 'px)',
					'width': 'auto',
					'min-width': inputWidth + 'px',
					'overflow-x': 'hidden'

				});
			};
		});
	};
	
	/**
	 * Petit plugin pour la création de popup qui se cale sur la largeur d'un bouton (façon dropdown)
	 * @param buildContent($menu) Callback permettant d'alimenter le contenu du $menu
	 * @param $button Bouton sur lequel on se cale en largeur
	 * @return nothing
	 */
	$.fn.showPopupMenu = function(buildContent, $button) {
		// Réutiliser le style visuel et le "z-index: 1000" du ".dropdown-menu" de Bootstrap
		var $menu = $('<div class="dropdown-menu" style="text-transform: uppercase;overflow:auto; display: block;">');
		buildContent($menu);

		var offset = $button.offset();

		$menu.css('left', offset.left);

		// On prend la largeur du composant.
		$menu.css('width', Math.round($button.outerWidth()));

		var scrollTop = $(window).scrollTop();
		var clientHeight = $(window).height();

		var top = offset.top + $button.height();

		if((top-scrollTop) > (clientHeight/2)) {
			setTimeout(function() {
				// Pop vers le haut.
				$menu.css({
					'top': (offset.top - $menu.height() - 10),
					'max-height': offset.top-scrollTop - 10,
				});
			}, 0);
		} else {
			// Pop vers le bas.
			$menu.css({
				'top': top,
				'max-height': clientHeight - (top-scrollTop) - 10,
			});
		}

		$menu.appendTo(document.body);

		var listenedElement = [];

		function hide() {
			$menu.remove();

			listenedElement.forEach(function($e) {
				$e.off('click', hide);
				$e.off('scroll', hide);
			});
		}

		// J'attends que l'événement soit passé avant de mettre en place le click qui fermera.
		setTimeout(function() {
			$button.parents().each(function(idx, e) {
				var $e = $(e);
				listenedElement.push($e);
				$e.on('click', hide);
				$e.on('scroll', hide);
			});
		}, 0);
	};

})(window.jQuery, window.moment);
